import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { exigir } from '../nucleo/autorizacion/guardian.js';
import { rutaRaiz } from './raiz.js';

/**
 * Grupo del operario y del jefe de operarios. El guardián se aplica UNA VEZ acá y todas
 * las rutas hijas lo heredan: el conteo de efectivo, el cover, las propinas y el cierre
 * no repiten una línea de verificación.
 *
 * La exigencia es `jornada.abrirCerrar` porque es la acción que define el grupo: quien
 * puede abrir y cerrar la jornada opera la noche. El contador la tiene en `no`, así que
 * queda fuera, que es exactamente lo que dice la matriz de la feature 2.
 */
export const rutaOperacion = createRoute({
  getParentRoute: () => rutaRaiz,
  id: '_operacion',
  beforeLoad: ({ context }) => ({ sesion: exigir(context, { accion: 'jornada.abrirCerrar' }) }),
  // El proveedor de consultas llega a pedido: la raiz viaja en el fragmento de entrada y
  // la pantalla de ingreso no usa react-query. Ver rutas/consultas.tsx.
  component: lazyRouteComponent(() => import('./consultas.js'), 'ProveedorConsultas'),
});
